import raw from './webhook.schema.json' with { type: 'json' };

import type { JsonSchema } from '#src/utils/jsonSchema.ts';

export const webhookSchema = raw as JsonSchema;
